/**
 * `/scores/search`, the Scores search for teams and players (ISSUE-1380).
 * The typed text is `?q=`. Named `scores_.search` so this route stays out of
 * `/scores`'s tree, which renders no Outlet, the same as `scores_.player`.
 */
import {
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { type ReactNode, useCallback } from "react";

import { requireSignedIn } from "../auth/requireSignedIn";
import { ScoreSearchScreen } from "../features/scoreSearch/ScoreSearchScreen";
import { validateScoreSearch } from "../routeState/scoreSearch";
import { SectionScreen } from "../shell/SectionScreen";

const ScoreSearchRoute = (): ReactNode => {
  const search = useSearch({ from: "/scores_/search" });
  const navigate = useNavigate({ from: "/scores/search" });
  const onQueryChange = useCallback(
    (next: string | undefined) => {
      void navigate({ search: { q: next }, replace: true });
    },
    [navigate],
  );
  return (
    // The nav bar's title is the page's h1.
    <SectionScreen heading={null}>
      <ScoreSearchScreen q={search.q} onQueryChange={onQueryChange} />
    </SectionScreen>
  );
};

export const Route = createFileRoute("/scores_/search")({
  beforeLoad: requireSignedIn,
  validateSearch: validateScoreSearch,
  component: ScoreSearchRoute,
});
